<template>
  <dashboard-widget title="EXCISE USER" no-zoom @delete="$emit('delete','DashboardExciseUser')" :width="width" :enableDelete="enableDelete">
    <v-autocomplete v-if="licenses.length > 1" :items="licenses" v-model="license" hide-details dense class="d-inline-block"
              style="position:absolute;top:10px;right:40px;width:120px" @change="refresh()"/>
    <v-container class="pa-0 ma-0 pt-6" @click="$router.push({name:'ReportsView', params:{back:[{text:'Dashboard',to:{name:'Dashboard'}}]},
                                                              query:{to:`reports/excise/ReportsExciseWarehouse`}})">
      <v-row class="mt-3">
        <v-col cols="5" class="py-3 text-body-2 pr-0">Spirits > 7%</v-col>
        <v-col class="text-right py-3">{{volumeForType(0) | number(3)}} LAA</v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="5" class="py-3 text-body-2 pr-0">Spirits &lt;= 7%</v-col>
        <v-col class="text-right py-3">{{0 | number(3)}} litres</v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="5" class="py-3 text-body-2 pr-0">Wine > 7%</v-col>
        <v-col class="text-right py-3">{{volumeForType(1) | number(3)}} litres</v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="5" class="py-3 text-body-2 pr-0">Wine &lt;= 7%</v-col>
        <v-col class="text-right py-3">{{volumeForType(2) | number(3)}} litres</v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="5" class="py-3 text-body-2 pr-0">Wine &lt;= 1.2%</v-col>
        <v-col class="text-right py-3">{{volumeForType(3) | number(3)}} litres</v-col>
      </v-row>
    </v-container>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardExciseUser',
  props: {
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      license: null,
      licenses: [],
      summaries: [],
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B263:true});
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardExciseUser {
                                            exciseUserSummary {
                                              license,alcoholType,volume
                                            }
                                          }`, {});
      if (!results.error) {
        this.licenses = [...new Set(this.sites.map(site => site.userLicense))];
        this.license = this.licenses[0];
        this.summaries = results.data.exciseUserSummary;
      }
    },
    volumeForType(type) {
      const t = this.summaries.find(s => s.license === this.license && s.alcoholType === type) || {volume:0};
      return t.volume;
    }
  }
}
</script>